import { ShortHelpSplitWindow } from "@/components/help";
// import { TradingSettings } from "@/components/profile/TradingSettingsSection";

export const ShortHelpPage = () => {
  return (
    <ShortHelpSplitWindow
      steps={[
        {
          title: "Создайте аккаунт на OKX",
          subtitle: "~2 минуты",
          showGuide: true,
          imageContent: (
            <div className="relative size-full overflow-hidden">
              <div className="flex size-full items-center justify-center px-6 py-10 lg:px-0 lg:py-0">
                <img
                  src="/images/shortHelp/p1.png"
                  alt=""
                  className="
                    pointer-events-none select-none object-contain w-auto

                    /* MOBILE */
                    absolute left-1/2 bottom-0 -translate-x-1/2 translate-y-[40%]
                    max-w-[92%] max-h-none
                    h-[clamp(10.625rem,54vw,17.5rem)]

                    /* TABLET (md) */
                    md:static md:translate-x-0 md:translate-y-0
                    md:h-auto md:max-h-[88%] md:max-w-[92%]

                    /* DESKTOP (lg)*/
                    lg:absolute lg:left-1/2 lg:bottom-0 lg:-translate-x-1/2 lg:translate-y-[23%]
                    lg:h-[min(135%,_96vh)] lg:w-auto lg:max-w-[90%] lg:max-h-none
                  "
                />
              </div>
            </div>
          ),
        },
        {
          title: "Пройдите верификацию",
          subtitle: "~5 минут",
          showGuide: true,
          imageContent: (
            <div className="relative flex size-full items-center justify-center overflow-hidden">
              <img
                src="/images/shortHelp/p2.png"
                alt=""
                className="
                  pointer-events-none select-none object-contain w-auto

                  /* MOBILE (<md) */
                  absolute left-1/2 bottom-0 -translate-x-1/2 translate-y-[12%]
                  max-w-[92%] max-h-none
                  h-[clamp(10.625rem,42vw,11.875rem)]

                  /* TABLET+ (md) */
                  md:static md:translate-x-0 md:translate-y-0
                  md:h-auto md:max-h-[88%] md:max-w-[90%]
                "
              />
            </div>
          ),
        },
        {
          title: "Нажмите «Создать API‑ключ»",
          subtitle: "~2 минуты",
          showGuide: true,
          additionalInfo: (
            <ul className="list-disc pl-5">
              <li className="mb-4">
                <span>
                  В доступах выберите <span className="text-primary">«Чтение»</span> и{" "}
                  <span className="text-primary">«Торговать»</span>
                </span>
              </li>
              <li className="mb-4">
                Поля
                <br />
                <span className="text-primary">«Название API»</span>
                <br />
                <span className="text-primary">«Парольная фраза»</span>
                <br />
                <span className="text-neutral-500">
                  Заполните и запомните (никому не показывайте!)
                </span>
              </li>
              <li>Эти данные нужно будет ввести в личном кабинете Spider</li>
            </ul>
          ),
          imageContent: (
            <div className="relative size-full overflow-hidden">
              <div className="flex size-full items-center justify-center px-6 py-10 lg:px-0 lg:py-0">
                <img
                  src="/images/shortHelp/p3.jpg"
                  alt=""
                  className="
                    pointer-events-none select-none object-contain w-auto

                    /* radius */
                    rounded-xs md:rounded-mds

                    /* MOBILE */
                    absolute left-1/2 bottom-0 -translate-x-1/2 translate-y-[42%]
                    max-w-[92%] max-h-none
                    h-[clamp(10.625rem,54vw,17.5rem)]

                    /* TABLET (md) */
                    md:static md:translate-x-0 md:translate-y-0
                    md:h-auto md:max-h-[88%] md:max-w-[92%]

                    /* DESKTOP (lg) */
                    lg:absolute lg:left-1/2 lg:bottom-0 lg:-translate-x-1/2 lg:translate-y-[22%]
                    lg:h-[min(135%,_96vh)] lg:w-auto lg:max-w-[90%] lg:max-h-none
                  "
                />
              </div>
            </div>
          ),
        },
        // {
        //   title: "Ограничить бота",
        //   subtitle: "Опционально",
        //   showGuide: false,
        //   imageContent: (
        //     <div className="absolute inset-0 flex items-center justify-center overflow-hidden">
        //       <img
        //         src="/images/shortHelp/p4.png"
        //         alt=""
        //         className="
        //           min-w-full object-cover mix-blend-screen
        //           translate-y-[20%] scale-120
        //           sm:scale-140
        //           md:translate-y-[30%] md:scale-180
        //         "
        //       />
        //     </div>
        //   ),
        //   additionalInfo: <TradingSettings />,
        // },
      ]}
      onOpenOkx={() => window.open("https://www.okx.com", "_blank")}
    />
  );
};
